import { generalFormErrors } from '@common/constants';

export const numericValidationPattern = {
  value: /^\d*\.?\d*$/,
  message: generalFormErrors.numericValidation,
};
